import styled from "styled-components";

export const Price = styled.div`
    display: flex;
    align-items: center;
`;